import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DataService } from './shared/services';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

    subscription: Subscription;

    constructor(private router: Router, public ds: DataService,
        private permissionsService: NgxPermissionsService,
        private roleService : NgxRolesService) {}

    ngOnInit() {
        this.subscription = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd)
            )
            .subscribe(() => window.scrollTo(0, 0));
    } 

    ngOnDestroy() {    
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}